module.exports = __webpack_public_path__ + "img/noinfo.df6e9b47.png";